import { Parhato2Coupon } from "./types";
import { convertParhato2Coupon } from "./converters";
import { BaseCouponsClient, Coupon } from "@core/types";

class CouponsClient extends BaseCouponsClient {
  async getCoupon(code: string): Promise<Coupon | null> {
    const response = await this.instance.get<Parhato2Coupon>("/wp-json/wc/v3/coupons", {
      params: {
        code,
      },
    });

    return response?.data ? convertParhato2Coupon(response.data) : null;
  }
}

export default CouponsClient;
